export const fetchVanityLinkInfo = (state) => state?.vanityLink;
